<template>
  <tr :style="member.death > 0 ? 'background-color: #d6d6d6' : ''">
    <td class="align-middle " style="width: 140px"> {{ member.info.nick }}</td>
    <td class="align-middle mr-2">{{ member.kills + killForSend }}</td>
    <td class="p-1 align-middle">
      <b-btn :disabled="disabled"
             @click="$emit('update:killForSend', killForSend + 1)"
             variant="primary"
             class="p-1 mr-4">
        <i class="fa fa-caret-up p-1 px-2"></i>
      </b-btn>
    </td>
    <td class="p-1 align-middle">
      <b-btn :disabled="disabled"
             @click="$emit('update:killForSend', killForSend - 1)"
             variant="danger"
             class="p-1 mr-4">
        <i class="fa fa-caret-down p-1 px-2"></i>
      </b-btn>
    </td>
    <td class="p-1 align-middle">
      <b-btn :disabled="disabled"
             @click="$emit('update:deathForSend', deathForSend === 1 ? 0 : 1)"
             :variant="deathForSend === 1 ? 'dark' : 'primary'"
             class="px-2 mr-4">
        {{ deathForSend === 1 ? 'Нет' : 'Да' }}
      </b-btn>
    </td>
  </tr>
</template>

<script>
export default {
  name: "RowInHostsBook",
  props: {
    member: {
      type: Object,
      default: null
    },
    team: {
      type: Object,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    killForSend: {
      type: Number,
      default: 0
    },
    deathForSend: {
      type: Number,
      default: 0
    },
  },
}
</script>
